// 将几个套模板公用的一些配置或者说引入的代码放到这边处理
import '@/scss/common.scss';
import '@/scss/topbar.scss';
import '@/scss/assessment.scss';

import 'babel-polyfill';
import dom from '@/util/dom';
import {Stream} from 'xstream';
import {extendXstream} from '@/lib/xstream.extra.js';
import '@/lib/xstream.platform';
import axios from 'axios';
import toast from '@/lib/toast';
import loading from '@/lib/loading';

import APIS from '@/util/apis';
import {setTitle, getPlatform} from '@/util/tool';
import {GetQueryString, objToUrlParams, loadScript, transHtmlToText} from '@/lib/util';
import Bridge from '@public/lib/Bridge';

import jumpMethodMixin from '@/mixins/pageJumper-mixin';
import {getUser, getUserKey, getVipinfo} from '@/entry/getUserKey'
import Stat from '@public/lib/stat/Stat';
import channelMap from '@/util/channelIdMap.config'
import getMP from '@/util/getMP'
import PageGrayFilter from '@/frontend-lib/component/PageGrayFilter/index'
import fakevconsole from '@/frontend-lib/lib/fakevconsole'
import vconsole from 'vconsole'
import { trackCreator } from '@yxl/libs'

const yxlConfig = require('../../yxlConfig.json')
console.log('=== box ===', yxlConfig.env.indexOf('box') === 0)
console.log('=== qc ===', yxlConfig.env.indexOf('qc') === 0)
console.log('=== !production ===', process.env.NODE_ENV !== 'production')
const VConsole = (yxlConfig.env.indexOf('box') === 0 || yxlConfig.env.indexOf('qc') === 0 || process.env.NODE_ENV !== 'production') ?
  vconsole : fakevconsole

extendXstream(require('xstream'))

const platform = getPlatform();
const isAPP = platform.isYixinliApp || platform.isCeShiApp;
const userAgent = navigator.userAgent
const isAliMp = GetQueryString('channelId') == 4925 || userAgent.indexOf('AlipayClient') > -1
const isMeiTuanMp = GetQueryString('channelId') == 5292 || /miniProgram MMP/i.test(userAgent)
console.log('=== isMeiTuanMp ===', isMeiTuanMp)

// 神策埋点
const track = trackCreator({})
function appTrackPageView (name, properties) {
  if (isAPP) {
    track.trackPageView(name, properties)
  }
}
function appTrackEvent (name, properties) {
  if (isAPP) {
    track.trackEvent(name, properties)
  }
}
function $trackPageView (name, properties) {
  track.trackPageView(name, properties)
}
function $trackEvent (name, properties) {
  track.trackEvent(name, properties)
}

// 支付宝 sdk + uniapp 跳转
const isMp = getMP()
window.$getMP = isMp
if (window.$getMP) {
  initMpSdk()
}
function initMpSdk() {
  console.log('=== initMpSdk ===')
  const userAgent = navigator.userAgent
  let thirdJs = ''
  if (userAgent.indexOf('AlipayClient') > -1) {
    // 支付宝小程序的 JS-SDK 防止 404 需要动态加载，如果不需要兼容支付宝小程序，则无需引用此 JS 文件。
    thirdJs = `https://appx/web-view.min.js`
  } else if (/miniProgram/i.test(userAgent)) {
    console.log('=== 美团小程序加载 微信sdk ===')
    // 微信小程序 JS-SDK 如果不需要兼容微信小程序，则无需引用此 JS 文件。
    thirdJs = `https://res.wx.qq.com/open/js/jweixin-1.6.0.js`
  }

  const uniJs = `https://js.cdn.aliyun.dcloud.net.cn/dev/uni-app/uni.webview.1.5.2.js`
  let loadUniScript = loadScript(thirdJs).then(() => {
    // 美团小程序不需要加载uni
    if (/miniProgram MMP/i.test(userAgent)) {
      // window.uni = window?.wx?.miniProgram
      window.uni = window.wx.miniProgram
    } else {
      loadScript(uniJs)
    }
  })

  function param(data) {
    let url = ''
    for (var k in data) {
      let value = data[k] !== undefined ? data[k] : ''
      // url += '&' + k + '=' + encodeURIComponent(value)
      url += '&' + k + '=' + value
    }
    return url ? url.substring(1) : ''
  }

  function togo(nav, data = {}) {
    if (!nav) return {}
    let url = ''
    if (Object.prototype.toString.call(nav) === '[object Object]') {
      if (nav.path) {
        url = nav.path
      } else if (nav.name) {
        url = `/pages/${nav.name}/${nav.name}`
      }

      data = {
        ...nav.data,
        ...nav.query,
        ...nav.params
      }
    } else {
      url = nav
    }
    url += (url.indexOf('?') < 0 ? '?' : '&') + param(data)
    return {
      url
    }
  }

  const push = function (nav, data = {}) {
    console.log('push', togo(nav, data))
    loadUniScript.then(() => {
      uni.navigateTo(togo(nav, data))
    })
  }

  const redirect = function (nav, data = {}) {
    console.log('redirect', togo(nav, data))
    loadUniScript.then(() => {
      uni.redirectTo(togo(nav, data))
    })
  }

  const login = function () {
    loadUniScript.then(() => {
      uni.navigateTo({
        url: isMeiTuanMp ? '/pages/login/login' : '/pages/login/index',  // 支付宝是 pages/login/index
      })
    })
  }

  window.$uniAppNavto = {
    push,
    redirect,
    login,
  }
}

Stream.ajax.defaultSetting = {
  proxyError: true,
  toastAPI: toast, // 代理处理错误时，用到的toast方法
  httpAPI: axios, // http模块。
  retry: 2
};
axios.defaults.withCredentials = true;
// 生产环境和服务端环境请求实际url
if (process.env.NODE_ENV === 'production' || !!process.env.VUE_ENV/* typeof window === 'undefined' */) {
  axios.interceptors.request.use(function (config) {
    if (config.url.indexOf('lingxikc/') == -1) {
      config.url = config.url.replace(/\/api(?:\/)/, APIS.cpapiHost).replace(/\/qu(?:\/)/, APIS.quHost).replace(/\/lx(?:\/)/, APIS.lingxiHost);
    }
    return config;
  });
}

async function initPage () {
  console.log(`---初始化页面---`);
  // 把后端给的分享信息重新处理
  let shareInfo = [];
  if (window.shareVo) {
    shareInfo = window.shareVo.replace('ShareVo', '').replace(/{|}/g, '').split(', ').map(item => {
      let equalIndex = item.indexOf('=') || 0;
      return item.slice(equalIndex + 1).replace(/\'/g, '') || '';
    });
  }
  // 建立桥和判断APP平台，设置分享配置
  if (isAPP && window.shareVo) {
    let {channelId} = await getRequireParams();
    const urlIsCeping = location.pathname.split('/')[1] === 'ceping'

    // 需求趣味测试更换域名
    const urlIsCeShi = location.pathname.split('/')[1] === 'ceshi'
    let newOrgin = `${location.protocol}//cp-wx${APIS.env ? APIS.env : ''}.xinli001.cc${location.pathname}`
    let isNewOrgin = urlIsCeShi
    let urlOrgin = isNewOrgin ? newOrgin : location.href.split('?')[0]

    let myBridge = new Bridge({
      methods: [{
        method: 'topFuncBtn',
        callback: (option) => {
          if (option.name === 'shareReportBtn') {
            myBridge.call('shareReport', {
              title: shareInfo[1],
              desc: shareInfo[2],
              link: urlOrgin + '?' + objToUrlParams({
                channelId
                // isCp: 1
              }),
              imgUrl: shareInfo[3],
              callbackName: 'shareReportCallback',
              // 动态分享的字段
              isShowDynamic: 1,
              object_id: shareInfo[0],
              object_type: urlIsCeping ? 12 : 6, // 12表示测评，6表示测试
              object_title: shareInfo[1],
              object_cover: shareInfo[3]
            });

            // 测评详情页
            if (urlIsCeping) {
              let urlArray = location.pathname.split('/');
              let scalePoolId = urlArray[urlArray.length - 1]
              // APP-测评详情页-点击分享 神策埋点
              appTrackEvent('app_cepingdetail_share', {
                test_id: scalePoolId,
                test_name: window.scaleName,
              })
            }
          }
        }
      }, {
        method: 'shareReportCallback',
        callback(options) {
          if (window.sharePageName) {
            let channelId = GetQueryString('channelId') || location.pathname.split('/')[4] || 513;
            let myTracker = new Stat({
              globalParams: {
                '渠道ID': channelId,
                '渠道': channelMap.map[channelId]
              }
            });
            // myTracker.stat(window.sharePageName, window.sharePagOption);
            myTracker.send({
              name: `v5100_测评_分享${window.sharePageName}`,
              properties: Object.assign(window.sharePagOption, {
                '分享渠道': options.shareChannel
              })
            });
          }
        }
      }]
    });
    myBridge.call('topFuncBtnConfig', {
      btnList: [{
        name: 'shareReportBtn',
        visible: 1,
        showName: platform.isCeShiApp ? '分享' : ''
      }]
    })
    // 设置标题栏和head的文字
    setTitle({isAPP, title: shareInfo[1] || '测试'});
  } else {
    if (isAPP) {
      setTitle({isAPP, title: '测试'});
    }
  }

  // topbar 后退功能
  if (!isAPP) {
    let topBack = document.querySelector('.topbar-left')
    topBack && topBack.addEventListener('click', e => {
      console.log(e);
      console.log(dom.closest(e.target, '.icon-wrap'));
      if (dom.closest(e.target, 'span')) {
        history.back()
      }
    });
  }

  // document.addEventListener('gesturestart', function (event) {
  //     event.preventDefault();
  // });

  // 禁用双指缩放：
  document.documentElement.addEventListener('touchstart', function (event) {
    if (event.touches.length > 1) {
      event.preventDefault();
    }
  }, false);
  // 禁用手指双击缩放：
  var lastTouchEnd = 0;
  document.documentElement.addEventListener('touchend', function (event) {
    var now = Date.now();
    if (now - lastTouchEnd <= 300) {
      event.preventDefault();
    }
    lastTouchEnd = now;
  }, false);

  // 百度统计代码
  if (!isAPP) {
    window._hmt = window._hmt || [];
    (function () {
      window.addEventListener('load', function load() {
        window.removeEventListener('load', load);

        var hm = document.createElement('script');
        hm.src = 'https://hm.baidu.com/hm.js?d64469e9d7bdbf03af6f074dffe7f9b5';
        var s = document.getElementsByTagName('script')[0];
        s.parentNode.insertBefore(hm, s);
      });
    })();
  }

  // 全国默哀置灰
  PageGrayFilter()
  // 谷歌统计代码
  // (function(i, s, o, g, r, a, m) {
  //   i['GoogleAnalyticsObject'] = r; i[r] = i[r] || function() {
  //     (i[r].q = i[r].q || []).push(arguments)
  //   }, i[r].l = 1 * new Date(); a = s.createElement(o),
  //   m = s.getElementsByTagName(o)[0]; a.async = 1; a.src = g; m.parentNode.insertBefore(a, m)
  // })(window, document, 'script', '//www.google-analytics.com/analytics.js', 'ga');
  // ga('create', 'UA-74218902-1', 'auto');
  // ga('send', 'pageview');
}

initPage();
let jumpMethods = jumpMethodMixin.methods;

// 全局的从APP获取登录信息的方法
window.getLogInParamsForTestPromise = new Promise(resolve => window.appLogInResolve = resolve);
window.getLogInParamsForTest = function (userData) {
  console.log('---客户端登陆完成---');
  console.log(JSON.parse(userData));
  // getLogInParamsForTestPromise.resolve(userData)
  window.appLogInResolve(JSON.parse(userData));
};

window.getLogInParamsForTestPromise.then((userData) => {
  loading('正在刷新页面');
  let channelId = GetQueryString('channelId') || location.pathname.split('/')[4] || 513;
  let params = Object.assign({}, {channelId}, userData)

  console.log('getUserKey的参数', params);

  getUserKey(params).then(({data: resData}) => {
    console.log(resData)
    getVipinfo({
      channelId: channelId,
      userKey: resData.data.userKey
    }).then((res) => {
      console.log('APP注入后获取的userKey等参数', resData.data);
      console.log('APP注入后获取的uvip等参数', res.data);
      // 给APP标记为测评的页面
      resData.data.isCp = 1;
      resData.data.channelId = channelId;
      console.log('去访问', `${location.origin}${location.pathname}?${objToUrlParams(resData.data)}&${objToUrlParams(res.data.data)}`);
      let targetUrl = `${location.origin}${location.pathname}?${objToUrlParams(resData.data)}&${objToUrlParams(res.data.data)}`
      if (window.userleft) {
        let callback = () => {
          window.userleft = false
          window.removeEventListener('appWebviewShow', callback)
          window.location.href = targetUrl;
        }
        window.addEventListener('appWebviewShow', callback)
      } else {
        window.location.href = targetUrl;
      }
    })
  })
})

async function getRequireParams() {
  // URL附带参数
  let channelId = 513;
  let userKey = GetQueryString('userKey') || '';
  let unionId = GetQueryString('unionId') || '';
  let token = GetQueryString('token') || '';
  let openId = GetQueryString('openId') || '';
  if (platform.isYixinliApp) {
    channelId = 514
  } else if (platform.isCeShiApp) {
    channelId = 324
  } else if (GetQueryString('channelId')) {
    channelId = GetQueryString('channelId')
  }

  console.log('url拿到的参数', {
    channelId,
    userKey,
    unionId
  });

  let newData = await getUser({
    channelId,
    token
  }).catch(err => {
    console.log(err);
  });

  if (+newData.code === 1) {
    userKey = newData.data.userKey;
    unionId = newData.data.unionId;
    openId = newData.data.openId;
  }
  return {
    openId,
    userKey,
    unionId,
    channelId
  };
}

export {
  VConsole,
  axios,
  Stream,
  Bridge,
  toast,
  APIS,
  platform,
  isAPP,
  isAliMp,
  isMeiTuanMp,
  dom,
  jumpMethods,
  Stat,
  getRequireParams,
  appTrackPageView,
  appTrackEvent,
  $trackPageView,
  $trackEvent,
};



// WEBPACK FOOTER //
// ./src/entry/templateCommon.js